export const AGENT_MCP_PASSWORD_MIN_BYTES = 10;
export const AGENT_MCP_PASSWORD_MAX_BYTES = 128;
const AGENT_MCP_USERNAME_PREFIX = 'kea-agent-';
const AGENT_MCP_USERNAME_ALPHABET = 'abcdefghijkmnopqrstuvwxyz';

function utf8Length(value) {
  if (typeof TextEncoder === 'function') {
    return new TextEncoder().encode(value).length;
  }
  return unescape(encodeURIComponent(value)).length;
}

function categoryCount(value) {
  return [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/]
    .reduce((count, pattern) => count + (pattern.test(value) ? 1 : 0), 0);
}

export function validateAgentMcpUsername(value) {
  return /^[a-z0-9][a-z0-9._-]{2,63}$/.test(String(value || '').trim().toLowerCase());
}

export function validateAgentMcpPassword(value) {
  const password = String(value || '');
  const bytes = utf8Length(password);
  if (bytes < AGENT_MCP_PASSWORD_MIN_BYTES || bytes > AGENT_MCP_PASSWORD_MAX_BYTES) return false;
  if (Array.from(password).some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  })) return false;
  const categories = categoryCount(password);
  return (bytes >= 24 && categories >= 2) || categories >= 3;
}

export function generateAgentMcpUsername(
  cryptoImpl = (typeof window !== 'undefined' ? window.crypto : null),
) {
  const bytes = new Uint8Array(7);
  if (cryptoImpl && typeof cryptoImpl.getRandomValues === 'function') {
    cryptoImpl.getRandomValues(bytes);
  } else {
    bytes.forEach((_value, index) => {
      bytes[index] = Math.floor(Math.random() * 256);
    });
  }
  const suffix = Array.from(bytes, byte => (
    AGENT_MCP_USERNAME_ALPHABET[byte % AGENT_MCP_USERNAME_ALPHABET.length]
  )).join('');
  return `${AGENT_MCP_USERNAME_PREFIX}${suffix}`;
}

export function generateAgentMcpPassword(
  cryptoImpl = (typeof window !== 'undefined' ? window.crypto : null),
) {
  if (!cryptoImpl || typeof cryptoImpl.getRandomValues !== 'function') {
    const error = new Error('Secure password generation is unavailable in this browser.');
    error.code = 'SECURE_RANDOM_UNAVAILABLE';
    throw error;
  }
  const required = [
    'ABCDEFGHJKLMNPQRSTUVWXYZ',
    'abcdefghijkmnopqrstuvwxyz',
    '23456789',
    '-_!@#$%',
  ];
  const alphabet = required.join('');
  const bytes = new Uint8Array(56);
  cryptoImpl.getRandomValues(bytes);
  const characters = required.map((charactersForType, index) => (
    charactersForType[bytes[index] % charactersForType.length]
  ));
  for (let index = characters.length; index < 28; index += 1) {
    characters.push(alphabet[bytes[index] % alphabet.length]);
  }
  for (let index = characters.length - 1; index > 0; index -= 1) {
    const swapIndex = bytes[28 + index] % (index + 1);
    [characters[index], characters[swapIndex]] = [characters[swapIndex], characters[index]];
  }
  return characters.join('');
}
